export const getShaderById = (id: string) => {
  return document.getElementById(id).innerHTML;
};
